import { useTranslation } from 'react-i18next';
import React from 'react';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';

const Title = () => {
  const { t } = useTranslation();

  return (
    <Typography
      className="leaderboard-title"
      color={COLOR.darkGray}
      variant="heading-32-bold"
      style={{
        textAlign: 'center',
      }}
    >
      📣 {t('highlightsOfTheWeek')}
    </Typography>
  );
};

export default Title;
